<div [ngClass]="{ 'm-toast__content': true, '--error': !data.success }">
  <i [class]="data.success ? 'icon-check-circle' : 'icon-alert-circle'" aria-hidden="true"></i>

  <app-text color="light-tint"> {{ data.message }}</app-text>
</div>
